const dynamicPackage = {
  detailedPlan: "แผนโดยละเอียด", // translated
  minimum: "ขั้นต่ำ", // translated
  maximum: "ขีดสุด", // translated
};

export default dynamicPackage;
